<template>
  <div class="precios">
    <div class="precios-int">
      <div v-if="precios['A']">
        <span class="precio-anual"
          >{{ precios["A"][0] | currencyEUR }} / año</span
        >
      </div>

      <div v-if="precios['S']">
        <span class="precio-alt">o pago semestral:</span>
        <ul class="precio-alt">
          <li>1er pago de {{ precios["S"][0] | currencyEUR }}</li>
          <li>2º pago de {{ precios["S"][1] | currencyEUR }}</li>
        </ul>
      </div>

      <div v-if="precios['T']">
        <span class="precio-alt">o pago trimestral:</span>
        <ul class="precio-alt">
          <li>1er pago de {{ precios["T"][0] | currencyEUR }}</li>
          <li>Siguientes de {{ precios["T"][1] | currencyEUR }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    precios: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.precios {
  font-size: 1.5rem;
  color: #e26f00;
  border: 2px solid #e26f00;
  border-radius: 0.7rem;
  padding: 1rem;
  width: 28rem;
  justify-content: center;
  align-items: center;
  display: flex;
}

.precio-anual {
  font-size: 3rem;
  font-weight: bold;
  display: block;
}

.precio-alt {
  display: block;
  font-size: 1.7rem;
  margin-top: 1rem;
}

ul {
  padding-left: 3rem;
  list-style-type: square;
}
</style>
